function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD476",
  d: "M23.492 33.603l-20.554-2.17a1 1 0 01-.567-1.735L34.261.72a1 1 0 011.612 1.082L24.536 32.951a1 1 0 01-1.044.652z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC445",
  d: "M24.316 33.288a1 1 0 01-.247-1.063L35.092 1.94a1 1 0 011.937.269l3.215 43.952a1 1 0 01-1.69.794L24.316 33.288z"
}));

var SvgDirection = function SvgDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgDirection;